export const Line = ({ ...props }) => {
  return (
    <>
      <svg
        className="line"
        width={"100%"}
        height={"100%"}
        stroke={props.style.borderColor ? props.style.borderColor : "#000000"}
        fill={props.style.borderColor ? props.style.borderColor : "#000000"}
      >
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="10"
            refY="3.5"
            orient="auto-start-reverse"
          >
            >
            <polygon points="0 0, 10 3.5, 0 7" />
          </marker>

          <marker
            id="transparentArrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="0.5"
            refY="3.5"
            orient="auto-start-reverse"
          >
            >
            <polygon points="0 0, 10 3.5, 0 7" fill={"transparent"} />
          </marker>

          <marker id="circle" markerWidth="8" markerHeight="8" refX="5" refY="5">
            <circle cx="5" cy="5" r="2" />
          </marker>

          <marker id="transparentCircle" markerWidth="8" markerHeight="8" refX="5" refY="5">
            <circle cx="5" cy="5" r="2" fill={"transparent"} />
          </marker>

          <marker id="square" markerWidth="7" markerHeight="7" refX="4" refY="4" orient="auto">
            <rect x="1.25" y="1.25" width="5" height="5" />
          </marker>

          <marker
            id="transparentSquare"
            markerWidth="7"
            markerHeight="7"
            refX="4"
            refY="4"
            orient="auto"
          >
            <rect x="1.25" y="1.25" width="5" height="5" fill={"transparent"} />
          </marker>

          <marker
            id="pointer"
            markerWidth="10"
            markerHeight="8"
            refX="9.5"
            refY="5.1"
            orient="-45"
            markerUnits="userSpaceOnUse"
          >
            <polyline points="1 1, 9 5, 1 7" />
          </marker>
        </defs>

        <g transform="scale(1) translate(0, 0.5)">
          <line
            x1="0"
            x2="100%"
            stroke-linecap="butt"
            fill="none"
            stroke-width={props.style.borderWeight ? props.style.borderWeight : "3"}
            marker-end={props.style.markerEnd ? props.style.markerEnd : ""}
            markerStart={props.style.markerStart ? props.style.markerStart : ""}
            stroke-dasharray={props.style.strokeStyle ? props.style.strokeStyle : "0 0"}
          ></line>
        </g>
      </svg>
    </>
  );
};

export const Arrow = ({ ...props }) => {
  return (
    <>
      <svg
        className="line"
        width={"100%"}
        height={"100%"}
        stroke={props.style.borderColor ? props.style.borderColor : "#000000"}
        fill={props.style.borderColor ? props.style.borderColor : "#000000"}
      >
        <defs>
          <marker
            id="arrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="10"
            refY="3.5"
            orient="auto-start-reverse"
          >
            >
            <polygon points="0 0, 10 3.5, 0 7" />
          </marker>

          <marker
            id="transparentArrowhead"
            markerWidth="10"
            markerHeight="7"
            refX="0.5"
            refY="3.5"
            orient="auto-start-reverse"
          >
            >
            <polygon points="0 0, 10 3.5, 0 7" fill={"transparent"} />
          </marker>

          <marker id="circle" markerWidth="8" markerHeight="8" refX="5" refY="5">
            <circle cx="5" cy="5" r="2" />
          </marker>

          <marker id="transparentCircle" markerWidth="8" markerHeight="8" refX="5" refY="5">
            <circle cx="5" cy="5" r="2" fill={"transparent"} />
          </marker>

          <marker id="square" markerWidth="7" markerHeight="7" refX="4" refY="4" orient="auto">
            <rect x="1.25" y="1.25" width="5" height="5" />
          </marker>

          <marker
            id="transparentSquare"
            markerWidth="7"
            markerHeight="7"
            refX="4"
            refY="4"
            orient="auto"
          >
            <rect x="1.25" y="1.25" width="5" height="5" fill={"transparent"} />
          </marker>

          <marker
            id="pointer"
            markerWidth="10"
            markerHeight="8"
            refX="9.5"
            refY="5.1"
            orient="-45"
            markerUnits="userSpaceOnUse"
          >
            <polyline points="1 1, 9 5, 1 7" />
          </marker>
        </defs>

        <g transform="scale(1) translate(0, 0.5)">
          <line
            x1="0"
            x2="100%"
            stroke-linecap="butt"
            fill="none"
            stroke-width={props.style.borderWeight ? props.style.borderWeight : "3"}
            marker-end={props.style.markerEnd ? props.style.markerEnd : ""}
            markerStart={props.style.markerStart ? props.style.markerStart : ""}
            stroke-dasharray={props.style.strokeStyle ? props.style.strokeStyle : "0 0"}
          ></line>
        </g>
      </svg>
    </>
  );
};

export const Elbow = ({ ...props }) => {
  return (
    <>
      <svg
        className="line"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 5.5C3.65311 5.5 4.20873 5.0826 4.41465 4.5H11.5V20C11.5 20.2761 11.7239 20.5 12 20.5H19.5854C19.7913 21.0826 20.3469 21.5 21 21.5C21.8284 21.5 22.5 20.8284 22.5 20C22.5 19.1716 21.8284 18.5 21 18.5C20.3469 18.5 19.7913 18.9174 19.5854 19.5H12.5V4C12.5 3.72386 12.2761 3.5 12 3.5H4.41465C4.20873 2.9174 3.65311 2.5 3 2.5C2.17157 2.5 1.5 3.17157 1.5 4C1.5 4.82843 2.17157 5.5 3 5.5Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};

export const Curved = ({ ...props }) => {
  return (
    <>
      <svg
        className="line"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 5.5C3.65311 5.5 4.20873 5.0826 4.41465 4.5H8C9.933 4.5 11.5 6.067 11.5 8V16C11.5 18.4853 13.5147 20.5 16 20.5H19.5854C19.7913 21.0826 20.3469 21.5 21 21.5C21.8284 21.5 22.5 20.8284 22.5 20C22.5 19.1716 21.8284 18.5 21 18.5C20.3469 18.5 19.7913 18.9174 19.5854 19.5H16C14.067 19.5 12.5 17.933 12.5 16V8C12.5 5.51472 10.4853 3.5 8 3.5H4.41465C4.20873 2.9174 3.65311 2.5 3 2.5C2.17157 2.5 1.5 3.17157 1.5 4C1.5 4.82843 2.17157 5.5 3 5.5Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};

export const Curve = ({ ...props }) => {
  return (
    <>
      <svg
        className="line"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3 5.5C3.82843 5.5 4.5 4.82843 4.5 4C4.5 3.17157 3.82843 2.5 3 2.5C2.17157 2.5 1.5 3.17157 1.5 4C1.5 4.82843 2.17157 5.5 3 5.5ZM21 21.5C21.8284 21.5 22.5 20.8284 22.5 20C22.5 19.1716 21.8284 18.5 21 18.5C20.1716 18.5 19.5 19.1716 19.5 20C19.5 20.8284 20.1716 21.5 21 21.5Z"
          fill="#585858"
        />
        <path
          d="M3 3.5C2.72386 3.5 2.5 3.72386 2.5 4C2.5 4.27614 2.72386 4.5 3 4.5V3.5ZM21 20.5C21.2761 20.5 21.5 20.2761 21.5 20C21.5 19.7239 21.2761 19.5 21 19.5V20.5ZM3 4.5H17V3.5H3V4.5ZM17 11.5H7V12.5H17V11.5ZM7 20.5H21V19.5H7V20.5ZM2.5 16C2.5 18.4853 4.51472 20.5 7 20.5V19.5C5.067 19.5 3.5 17.933 3.5 16H2.5ZM7 11.5C4.51472 11.5 2.5 13.5147 2.5 16H3.5C3.5 14.067 5.067 12.5 7 12.5V11.5ZM20.5 8C20.5 9.933 18.933 11.5 17 11.5V12.5C19.4853 12.5 21.5 10.4853 21.5 8H20.5ZM17 4.5C18.933 4.5 20.5 6.067 20.5 8H21.5C21.5 5.51472 19.4853 3.5 17 3.5V4.5Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};

export const PolyLine = ({ ...props }) => {
  return (
    <>
      <svg
        className="line"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 20V20.5C22.1894 20.5 22.3625 20.393 22.4472 20.2236C22.5319 20.0542 22.5136 19.8515 22.4 19.7L22 20ZM22 4L22.4 4.3C22.5136 4.14849 22.5319 3.94579 22.4472 3.77639C22.3625 3.607 22.1894 3.5 22 3.5V4ZM9.5 4V3.5C9.3618 3.5 9.22975 3.5572 9.13523 3.65803L9.5 4ZM2 12L1.63523 11.658C1.45492 11.8504 1.45492 12.1496 1.63523 12.342L2 12ZM9.5 20L9.13523 20.342C9.22975 20.4428 9.3618 20.5 9.5 20.5V20ZM16 12L15.6 11.7C15.4667 11.8778 15.4667 12.1222 15.6 12.3L16 12ZM22 3.5H9.5V4.5H22V3.5ZM9.5 20.5H22V19.5H9.5V20.5ZM22.4 19.7L16.4 11.7L15.6 12.3L21.6 20.3L22.4 19.7ZM16.4 12.3L22.4 4.3L21.6 3.7L15.6 11.7L16.4 12.3ZM1.63523 12.342L9.13523 20.342L9.86477 19.658L2.36477 11.658L1.63523 12.342ZM9.13523 3.65803L1.63523 11.658L2.36477 12.342L9.86477 4.34197L9.13523 3.65803Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};

export const Scribble = ({ ...props }) => {
  return (
    <>
      <svg
        className="line"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.626295 5.07057C0.442836 5.27696 0.461427 5.59299 0.667818 5.77645C0.874209 5.95991 1.19025 5.94132 1.3737 5.73493L0.626295 5.07057ZM6.5 9.90275L6.96817 10.0783L6.5 9.90275ZM16.5 9.90275L16.6857 9.43851L16.5 9.90275ZM22.924 14.3971C23.1969 14.439 23.4522 14.2518 23.4942 13.9789C23.5362 13.706 23.349 13.4507 23.076 13.4087L22.924 14.3971ZM19.1203 18.3162L18.6268 18.2355L19.1203 18.3162ZM15.2662 19.5633L14.9143 19.9186L15.2662 19.5633ZM6.73958 18.2892L6.68623 18.7863L6.73958 18.2892ZM1.3737 5.73493C2.00183 5.0283 2.87521 4.32691 3.76914 3.83131C4.68118 3.32566 5.52793 3.082 6.12652 3.16625C6.40812 3.20589 6.62188 3.31544 6.7814 3.49772C6.94598 3.68578 7.09009 3.99424 7.14566 4.49429C7.25877 5.51197 6.98888 7.17501 6.03183 9.72719L6.96817 10.0783C7.93939 7.48834 8.27947 5.64279 8.13954 4.38382C8.0686 3.74555 7.87044 3.22366 7.53391 2.83914C7.19234 2.44885 6.74615 2.24361 6.26589 2.17601C5.34074 2.0458 4.25606 2.41795 3.28426 2.95673C2.29436 3.50554 1.33151 4.2772 0.626295 5.07057L1.3737 5.73493ZM6.03183 9.72719C5.39285 11.4312 4.83283 13.5173 4.74576 15.2334C4.7025 16.0861 4.77258 16.9022 5.05157 17.5421C5.34452 18.2139 5.87701 18.6995 6.68623 18.7863L6.79293 17.792C6.39905 17.7498 6.14261 17.5423 5.96823 17.1424C5.77992 16.7105 5.70431 16.0759 5.74448 15.2841C5.82427 13.7113 6.34755 11.7333 6.96817 10.0783L6.03183 9.72719ZM9.55847 16.3608C10.545 13.7882 11.7266 12.0558 12.9194 11.0905C14.0963 10.1381 15.2582 9.94454 16.3143 10.367L16.6857 9.43851C15.2253 8.85435 13.6867 9.18307 12.2903 10.3132C10.9098 11.4304 9.64552 13.3409 8.62477 16.0028L9.55847 16.3608ZM16.3143 10.367C17.2921 10.7581 18.0184 11.8483 18.4266 13.366C18.8291 14.8626 18.8854 16.6542 18.6268 18.2355L19.6137 18.3969C19.8926 16.6917 19.8358 14.7553 19.3923 13.1063C18.9545 11.4783 18.102 10.0051 16.6857 9.43851L16.3143 10.367ZM15.618 19.2081C15.1311 18.7258 14.7816 18.2175 14.6409 17.7138C14.5067 17.2332 14.5522 16.726 14.916 16.1802L14.084 15.6255C13.5569 16.4161 13.466 17.2245 13.6778 17.9828C13.8831 18.7179 14.3621 19.3717 14.9143 19.9186L15.618 19.2081ZM14.916 16.1802C15.5928 15.1651 16.989 14.6094 18.6098 14.3726C20.2044 14.1397 21.8782 14.2362 22.924 14.3971L23.076 13.4087C21.9551 13.2362 20.1789 13.1328 18.4652 13.3831C16.7776 13.6297 15.0072 14.2406 14.084 15.6255L14.916 16.1802ZM18.6268 18.2355C18.3827 19.7281 16.6955 20.2753 15.618 19.2081L14.9143 19.9186C16.5662 21.5548 19.2378 20.6954 19.6137 18.3969L18.6268 18.2355ZM6.68623 18.7863C7.46217 18.8696 8.08996 18.5126 8.55153 18.0336C9.00735 17.5606 9.33798 16.9358 9.55847 16.3608L8.62477 16.0028C8.43123 16.5075 8.16073 16.9981 7.83149 17.3397C7.508 17.6754 7.16679 17.8322 6.79293 17.792L6.68623 18.7863Z"
          fill="#585858"
        />
      </svg>
    </>
  );
};
